import {CreditNote} from '../models/credit.note/creditNote.model';

export namespace CreditNotes {
  export class GetCreditNotes {
    static readonly type = '[Credit Note api] Get Credit Notes';

    constructor(public force: boolean = false) {
    }
  }

  export class GetCreditNote {
    static readonly type = '[Credit Note api] Get Credit Note';

    constructor(public id: string, public force: boolean = false) {
    }
  }

  export class CreateCreditNote {
    static readonly type = '[Credit Note api] Create Credit Note';

    constructor(public creditNote: CreditNote) {
    }
  }

  export class UpdateCreditNote {
    static readonly type = '[Credit Note api] Update Credit Note';

    constructor(public creditNote: CreditNote) {
    }
  }

  export class DeleteCreditNote {
    static readonly type = '[Credit Note api] Delete Credit Note';

    constructor(public creditNote: CreditNote) {
    }
  }
}
